export default __webpack_public_path__ + "static/media/b-16.dbee62f0.png";